import React from 'react';
import { Alert } from 'reactstrap';

export default function Loading({ ...props }) {
  return (
    <Alert color="light" {...props}>
      Loading…
    </Alert>
  );
}
